import angular from 'angular';
import home from './home/home';
import face from './face/face';
import page from './page/page';

let modules = [home, face, page];

let moduleNames = [];

modules.forEach((m) => {
    moduleNames.push(m.name);
});

let componentModule = angular.module('app.components', moduleNames)

    .config(($stateProvider) => {
        "ngInject";

        modules.forEach((m) => {
            m.states.forEach((state) => {

                state.name = 'app.' + state.name;


                $stateProvider.state(state);
            });
        });
    })

    .name;

export default componentModule;



// WEBPACK FOOTER //
// ./src/app/components/components.js